// extracted by mini-css-extract-plugin
module.exports = {"radioGroup":"RadioGroup-module__radioGroup","shake":"RadioGroup-module__shake"};